---
import SubscribeForm from "./SubscribeForm.svelte";

---

<div id="email-subscription">
  <SubscribeForm {...Astro.props} client:visible />
</div>